import { TeflOlComment } from '../../../lib/types/models/tefl-ol-comment/tefl-ol-comment'
import { TeflOlCommentRequest } from '../../../lib/types/models/tefl-ol-comment/tefl-ol-comment-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateTeflOlComment = async (
  data: UpdateInput<TeflOlCommentRequest> & { teflId: number }
) => {
  const { id, teflId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.tefl.updateTeflOlComment.url, { id, teflId }))
    .patch<TeflOlComment, Partial<TeflOlCommentRequest>>(rest)
}
